import { useTranslation } from "react-i18next";
// Functions
import { getTrainedMinutesAndSeconds } from "../../config/functions";
// Components
import {
  AdherenceDiv,
  PositionerTimeButtonsDiv,
  TimeButtonsDiv,
  TimeButton,
  SeparatorLine,
  Title,
  GraphicsDiv,
  DataShowedDescriptionText,
} from "./styles";
import AdherenceProgressBar from "./adherenceProgressBar";
import DownloadFiles from "../reports/sections/downloadFiles";

const AdherenceWheels = ({ adherenceObject, sessionTimeRange, setSessionTimeRange, sessionsData = [], showFilesDownload, plotsRef }) => {
  const [t] = useTranslation("global");

  const renderDownloadFiles = () => {
    if (showFilesDownload) {
      return <DownloadFiles sessionsData={sessionsData} plotsRef={plotsRef} />;
    }
  };

  return (
    <AdherenceDiv>
      <PositionerTimeButtonsDiv justifyContent={showFilesDownload ? "space-between" : "flex-end"}>
        {renderDownloadFiles()}
        <TimeButtonsDiv>
          <TimeButton onClick={() => setSessionTimeRange("WEEK")} active={sessionTimeRange === "WEEK"}>
            {t("adherence_week")}
          </TimeButton>
          <SeparatorLine />
          <TimeButton onClick={() => setSessionTimeRange("MONTH")} active={sessionTimeRange === "MONTH"}>
            {t("adherence_month")}
          </TimeButton>
          <SeparatorLine />
          <TimeButton onClick={() => setSessionTimeRange("THREE_MONTHS")} active={sessionTimeRange === "THREE_MONTHS"}>
            {t("adherence_threeMonth")}
          </TimeButton>
          <SeparatorLine />
          <TimeButton onClick={() => setSessionTimeRange("ALL_MONTHS")} active={sessionTimeRange === "ALL_MONTHS"}>
            {t("adherence_allMonths")}
          </TimeButton>
        </TimeButtonsDiv>
      </PositionerTimeButtonsDiv>
      <Title>{t("adherence")}</Title>
      <GraphicsDiv>
        {/* Days adherence */}
        <AdherenceProgressBar
          percentage={adherenceObject.daysAdherence}
          prescribedData={adherenceObject.prescribedDays}
          trainedData={adherenceObject.trainedDays}
          prescribedDataTitle={t("adherence_prescribedDays")}
          trainedDataTitle={t("adherence_trainedDays")}
        />
        {/* Sessions adherence */}
        <AdherenceProgressBar
          percentage={adherenceObject.sessionsAdherence}
          prescribedData={adherenceObject.prescribedSessions}
          trainedData={adherenceObject.trainedSessions}
          prescribedDataTitle={t("adherence_prescribedSessions")}
          trainedDataTitle={t("adherence_trainedSessions")}
        />
        {/* Minutes adherence */}
        <AdherenceProgressBar
          percentage={adherenceObject.minutesAdherence}
          prescribedData={isNaN(adherenceObject.prescribedMinutes) ? 0 : Math.round(adherenceObject.prescribedMinutes)}
          trainedData={getTrainedMinutesAndSeconds(adherenceObject.trainedSeconds)}
          prescribedDataTitle={t("prescribedMinutes")}
          trainedDataTitle={t("adherence_trainedMinutes")}
        />
      </GraphicsDiv>
      <DataShowedDescriptionText>{t("adherence_dataShowedDescription")}</DataShowedDescriptionText>
    </AdherenceDiv>
  );
};

export default AdherenceWheels;
